import clsx from 'clsx';
import { useFormikContext } from 'formik';
import { useContext, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { AppContext } from '../../../../appContext/AppContext';
import CustomIconButton from '../../../../component/custom-icon-button/CustomIconButton';
import LazyLoadTable from '../../../../component/lazy-load-table/LazyLoadTable';
import {
	getDanhSachDatLichHen,
	getThongTinBenhNhanDatLich
} from '../../../../phan-he-kham-benh/services/DatLichHenService';
import {
	APP_LOCAL_DATE_FORMAT,
	CODE,
	ID_DANG_KY_KHAM,
	KEY_DS_DANH_MUC_TIEP_DON,
	RESPONSE_MESSAGE
} from '../../../../utils/Constant';
import { formatDateTime } from '../../../../utils/FormatUtils';
import { getIndexedDBItem } from '../../../../utils/IndexedDB';
import { CODE_DOI_TUONG } from '../../../constants/PhanHeTiepNhan';
import { IDanhSachDanhMuc } from '../../../models/TiepDonModel';
import { PhanHeTiepNhanContext } from '../../../PhanHeTiepNhan';
import { APPOINTMENT_STATUS, DANH_SACH_DAT_LICH_HEN_COLUMNS } from './constants';
// import Filter from './Filter';

const TabDanhSachDatLichHen = () => {
	const { setIsLoading } = useContext(AppContext);
	const { setValues, values } = useFormikContext<any>();
	const { thongTinBenhNhan, setThongTinBenhNhan, convertDataBenhNhan } =
		useContext(PhanHeTiepNhanContext);

	const [query, setQuery] = useState<any>({
		fromDate: formatDateTime(new Date(), APP_LOCAL_DATE_FORMAT),
		toDate: formatDateTime(new Date(), APP_LOCAL_DATE_FORMAT),
	});
	const categoriesRef = useRef<IDanhSachDanhMuc>();

	useEffect(() => {
		getCategories();
	}, []);

	useEffect(() => {
		setQuery({
			...query,
			patientId: values?.patient?.id,
		});
	}, [values?.patient?.id]);

	const getCategories = async () => {
		try {
			const responseDsDanhmuc: IDanhSachDanhMuc = await getIndexedDBItem(
				KEY_DS_DANH_MUC_TIEP_DON
			);
			categoriesRef.current = responseDsDanhmuc;
		} catch (error) {
			console.error(error);
		}
	};

	const onView = async (row: any) => {
		if (APPOINTMENT_STATUS.APPOINTMENT_CANCELED === row?.currStatusCode) {
			return;
		}

		try {
			setIsLoading(true);
			const appointmentId = row.id;
			const { code, data } = await getThongTinBenhNhanDatLich(appointmentId);
			if (CODE.SUCCESS === code) {
				const VISIT_TYPE_DEFAULT = categoriesRef.current?.listDKKham?.find(
					(item: any) => item?.id === ID_DANG_KY_KHAM.KHAM_BENH
				);
				const VISIT_OBJECT_TYPE_DEFAULT = categoriesRef.current?.listDoiTuong?.find(
					(item: any) => item?.code === CODE_DOI_TUONG.YEU_CAU
				);
				const INSURANCE_OBJECT_TYPE = categoriesRef.current?.listDoiTuong.find(
					(item: any) => CODE_DOI_TUONG.BAO_HIEM === item?.code
				);

				const dataFormatted = {
					...data,
					appointmentId: data.appointment.id,
					visit: {
						visitReasonName: data.appointment.reason,

						visitTypeCode: VISIT_TYPE_DEFAULT?.code,
						visitTypeId: VISIT_TYPE_DEFAULT?.id,
						visitTypeName: VISIT_TYPE_DEFAULT?.name,

						visitObjectTypeCode: data?.insurance
							? INSURANCE_OBJECT_TYPE?.code
							: VISIT_OBJECT_TYPE_DEFAULT?.code,
						visitObjectTypeId: data?.insurance
							? INSURANCE_OBJECT_TYPE?.id
							: VISIT_OBJECT_TYPE_DEFAULT?.id,
						visitObjectTypeName: data?.insurance
							? INSURANCE_OBJECT_TYPE?.name
							: VISIT_OBJECT_TYPE_DEFAULT?.name,

						termSvcId: data.appointment.termId,
						termSvcCode: data.appointment.termCode,
						termSvcName: data.appointment.termName,

						deptId: data.appointment.departmentId,
						deptCode: data.appointment.departmentCode,
						deptName: data.appointment.departmentName,
					},
				};
				const dataConverted = convertDataBenhNhan(dataFormatted);
				setValues(dataConverted);
				setThongTinBenhNhan({
					...thongTinBenhNhan,
					isExamined: data?.data?.isExamined,
					isMedicalExamSvcPaid: data?.data?.isMedicalExamSvcPaid,
				});
			} else {
				toast.error(RESPONSE_MESSAGE.ERROR);
			}
		} catch (error) {
			toast.error(RESPONSE_MESSAGE.ERROR);
			console.error(error);
		} finally {
			setIsLoading(false);
		}
	};

	const columnActions = {
		name: 'Thao tác',
		headerStyle: {
			maxWidth: '80px',
		},
		render: (rowData: any, index: number) => (
			<div className="d-flex justify-content-center">
				<CustomIconButton
					variant="edit"
					onClick={() => {
						onView(rowData);
					}}
					title="Xem thông tin bệnh nhân đặt lịch"
					className={clsx('h-24 d-flex align-items-center', {
						invisible: [
							APPOINTMENT_STATUS.APPOINTMENT_COMPLETED,
							APPOINTMENT_STATUS.APPOINTMENT_CANCELED,
						].includes(rowData.currStatusCode),
					})}
				>
					<i className="bi bi-eye text-navy"></i>
				</CustomIconButton>
			</div>
		),
	};

	return (
		<div className="spaces py-8 mx-0">
			{/* <Filter
				query={query}
				onSearch={(params) =>
					setQuery({
						...query,
						...params,
					})
				}
			/> */}
			<LazyLoadTable
				columns={[columnActions, ...DANH_SACH_DAT_LICH_HEN_COLUMNS]}
				axiosReq={getDanhSachDatLichHen}
				searchData={query}
				urlData="data.data.content"
				rowKey="id"
			/>
		</div>
	);
};

export default TabDanhSachDatLichHen;
